import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import { IconBackArrow } from 'src/viewLayer/components/DesignSystem'
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink'
import { onBackButtonClicked } from 'src/viewLayer/helpers/safeNativeReporter'
import { hasNativeBackButton, useEmailPagePath } from 'src/viewLayer/navigation'

import { BackButtonContainer } from './index.styled'

export default (properties) => {
  const { devicePath } = useAppConfigContext()
  const navigate = useNavigate()
  const emailPagePath = useEmailPagePath()

  const isNativeMobile = devicePath === 'login-mobile'

  if (!isNativeMobile || hasNativeBackButton()) {
    return null
  }

  // Back button in email and business view native
  const renderEmailBackButton = () => {
    const trackingId =
      properties.path === 'email' ? 'email_back_button_webview' : 'b2b_sso_back_button_webview'
    return (
      <BackButtonContainer>
        <TrackableLink
          {...properties}
          aria-label="email_login.btn.back"
          data-testid="back-button-webview"
          href="#"
          icon={<IconBackArrow />}
          onClick={onBackButtonClicked}
          trackingId={trackingId}
        />
      </BackButtonContainer>
    )
  }

  const goBack = () => {
    if (globalThis.history.state?.idx > 0) {
      navigate(-1)
    } else {
      navigate(emailPagePath, { replace: true })
    }
  }
  const renderHistoryBackButton = (ariaLabel) => {
    return (
      <BackButtonContainer>
        <TrackableLink
          {...properties}
          aria-label={ariaLabel}
          as="button"
          className="BackButton"
          data-testid="back-button-default"
          icon={<IconBackArrow />}
          onClick={goBack}
        />
      </BackButtonContainer>
    )
  }

  switch (properties.path) {
    case 'business':
    case 'email':
      return renderEmailBackButton()
    case 'forgot-password':
      return renderHistoryBackButton('forgot_password.btn.back')
    case 'password':
      return renderHistoryBackButton('passsword.btn.back')
    default:
      throw new Error(`BackButton: unhandled path "${properties.path}"`)
  }
}
